import { IMGPW } from '@/config';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {Button} from 'src/components/commons/Button';
import {Link} from '@/navigation';

const encode = (data) => {
  return Object.keys(data)
    .map(
      (key) =>
        encodeURIComponent(key.replace('_', '.')) +
        '=' +
        encodeURIComponent(data[key]),
    )
    .join('&');
};

const SectionContact = ({src}) => {
  const t = useTranslations('google-forms');

  return (
    <Formik
      initialValues={{
        // Nome
        entry_2005620554: '',
        // Cognome
        entry_1045781291: '',
        // Città di interesse
        entry_1065046570: '',
        // Telefono
        entry_1166974658: '',
        // E-mail
        entry_839337160: '',
        // Cap
        entry_1488223336: '',
        // Provincia
        entry_26808942: '',
        // Come se venuto a conoscenza dell'opportunita
        entry_1454812694: '',
        // Informazione aggiuntive
        entry_319585540: '',
        // Format di interesse
        entry_1357973781: '',
        // Quando vorresti iniziare l’attività?
        entry_1123951239: '',
        // Dotazione iniziale capitale
        entry_635215164: '',
        // Location
        entry_529228300: '',
        privacy: false,
      }}
      initialStatus={{error: '', success: ''}}
      onSubmit={async (values, actions) => {
        if (!values.privacy) {
          actions.setSubmitting(false);
          return actions.setErrors({
            privacy: 'Accetta la privacy prima di inviare il form',
          });
        }

        try {
          const response = await fetch(
            'https://docs.google.com/forms/d/e/1FAIpQLSff4vTV5_dCmL0osgfXEJeVOYwbRtBfsFuJzQjadDW2I8cFXw/formResponse',
            {
              headers: {'Content-Type': 'application/x-www-form-urlencoded'},
              method: 'POST',
              mode: 'no-cors',
              body: encode({
                ...values,
                entry_768371069: src,
              }),
            },
          );
          actions.setStatus({ success: true });
        } catch (err) {
          actions.setStatus({
            error: t('common.error'),
          });
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({
        values,
        errors,
        status,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
      }) => {
        return (
          <div className="container">
            <h3
              id="affiliazione"
              className="tw-text-4xl tw-pb-2 tw-tracking-tighter tw-font-bold tw-scroll-mt-32 tw-text-gray-800"
            >
              Füllen Sie das Formular aus und bewerben Sie sich
            </h3>

            <Form>
              <div className="md:tw-grid md:tw-grid-cols-2 tw-gap-x-4">
                <div className="form-group tw-col-span-1">
                  <label>{t('AffiliazioneForm.label.name')}</label>
                  <Field
                    placeholder={t('AffiliazioneForm.placeholder.name')}
                    disabled={isSubmitting}
                    name="entry_2005620554"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_2005620554"
                    className="text-danger"
                  />
                </div>
                <div className="form-group">
                  <label>{t('AffiliazioneForm.label.email')}</label>
                  <Field
                    placeholder={t('AffiliazioneForm.placeholder.email')}
                    disabled={isSubmitting}
                    name="entry_839337160"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_839337160"
                    className="text-danger"
                  />
                </div>

                <div className="form-group">
                  <label>{t('AffiliazioneForm.label.phone')}</label>
                  <Field
                    placeholder={t('AffiliazioneForm.placeholder.phone')}
                    disabled={isSubmitting}
                    name="entry_1166974658"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_1166974658"
                    className="text-danger"
                  />
                </div>

                {/*<div className="form-group">
                  <label>{'Cap'}</label>
                  <Field
                    placeholder={'Cap'}
                    disabled={isSubmitting}
                    name="entry_1488223336"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_1488223336"
                    className="text-danger"
                  />
                </div>*/}

                <div className="form-group">
                  <label>{t('AffiliazioneForm.label.city')}</label>
                  <Field
                    placeholder={t('AffiliazioneForm.placeholder.city')}
                    disabled={isSubmitting}
                    name="entry_1065046570"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_1065046570"
                    className="text-danger"
                  />
                </div>
                {/*<div className="form-group">
                  <label>{'Provincia'}</label>
                  <Field
                    placeholder={'Provincia'}
                    disabled={isSubmitting}
                    name="entry_26808942"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_26808942"
                    className="text-danger"
                  />
                </div>*/}

                {/*<div className="form-group">
                  <label>
                    Come sei venuto a conoscenza dell'opportunità
                  </label>
                  <Field
                    placeholder="Come sei venuto a conoscenza dell'opportunità"
                    disabled={isSubmitting}
                    name="entry_1454812694"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_1454812694"
                    className="text-danger"
                  />
                </div>*/}

                <div className="form-group">
                  <label>{'Format von Interesse'}</label>

                  <Field
                    component="select"
                    placeholder="Format von Interesse"
                    disabled={isSubmitting}
                    name="entry_1357973781"
                    className="form-control form-control-rounded"
                    required
                  >
                    <option value="" disabled>
                      Wählen Sie ein Format aus
                    </option>
                    <option value="Winelivery Bar & Enoteca">
                      Winelivery Bar & Weinladen
                    </option>
                    <option value="Enoteca con Delivery">
                      Weinladen mit Lieferung
                    </option>
                    <option value="Pimp my store">Pimp meinen Laden</option>
                  </Field>
                  <ErrorMessage
                    name="entry_1357973781"
                    className="text-danger"
                  />
                </div>

                <div className="form-group">
                  <label>Wann möchten Sie mit dem Unternehmen beginnen?</label>

                  <Field
                    component="select"
                    placeholder="Seleziona un periodo"
                    disabled={isSubmitting}
                    name="entry_1123951239"
                    className="form-control form-control-rounded"
                    required
                  >
                    <option value="" disabled>
                      Wählen Sie einen Zeitraum aus
                    </option>
                    <option value="0-3 mesi">0-3 Monate</option>
                    <option value="3-6 mesi">3-6 Monate</option>
                    <option value="6-12 mesi">6-12 Monate</option>
                    <option value="1 anno o più">1 Jahr oder länger</option>
                  </Field>
                  <ErrorMessage
                    name="entry_1123951239"
                    className="text-danger"
                  />
                </div>

                <div className="form-group">
                  <label>
                    Anfangskapitalausstattung
                  </label>
                  <Field
                    name="entry_635215164"
                    disabled={isSubmitting}
                    placeholder="Dotazione di capitale iniziale"
                    className="form-control form-control-rounded"
                    component="select"
                    required>
                    <option value="" disabled>
                      Wählen Sie ein Loadout aus
                    </option>
                    <option value="0">
                      Keiner
                    </option>
                    <option value="< 25.000€">
                      {'Weniger als 25.000€'}
                    </option>
                    <option value="25.000€ - 50.000€">
                      {'Zwischen 25.000€ und 50.000€'}
                    </option>
                    <option value="> 50.000€">
                      {'Über 50.000€'}
                    </option>
                  </Field>
                  <div className="tw-text-red-500">
                    <ErrorMessage name="entry_635215164" />
                  </div>
                </div>

                <div className="form-group">
                  <label>
                    Der Standort ist
                  </label>
                  <Field
                    name="entry_529228300"
                    disabled={isSubmitting}
                    placeholder="Der Standort ist"
                    className="form-control form-control-rounded"
                    component="select"
                    required>
                    <option value="" disabled>
                      {'Wählen Sie einen Standortstatus aus'}
                    </option>
                    <option value="da individuare">
                      {'Zu identifizieren'}
                    </option>
                    <option value="già individuata">
                      {'Bereits identifiziert'}
                    </option>
                    <option value="già disponibile">
                      {'Bereits zur Einrichtung verfügbar'}
                    </option>
                  </Field>
                  <div className="tw-text-red-500">
                    <ErrorMessage name="entry_529228300" />
                  </div>
                </div>

                <div className="form-group tw-col-span-2">
                  <label>
                    Erzählen Sie uns mehr über sich und Ihr Interesse daran Winelivery-Format
                  </label>
                  <Field
                    component="textarea"
                    rows="4"
                    disabled={isSubmitting}
                    name="entry_319585540"
                    className="form-control form-control-rounded"
                    required
                  />
                  <ErrorMessage
                    name="entry_319585540"
                    className="text-danger"
                  />
                </div>

                <div className="form-group tw-inline tw-col-span-2 tw-mb-0 tw-pb-0">
                  <Field
                    name="privacy"
                    className="mr-2 leading-tight "
                    type="checkbox"
                    required
                  />
                  <label className="tw-inline">
                    Wir verarbeiten die erhobenen Daten gemäß den in der Datenschutzrichtlinie angegebenen Bedingungen{' '}
                    <Link href={`/privacy`}>an diese Adresse</Link>
                  </label>
                  <div className="tw-mt-4 tw-text-red-500">
                    <ErrorMessage name="privacy" />
                  </div>
                </div>
                <div className="tw-col-span-2">
                  {status && status.error && (
                    <div
                      className="md:tw-w-1/2 tw-mx-auto tw-relative tw-p-6 tw-rounded tw-border tw-bg-[#ff52521f] tw-border-error-dark tw-text-error-dark">
                      {status.error}
                    </div>
                  )}
                  {(
                    <div
                      className="md:tw-w-5/12 tw-mx-auto tw-relative tw-p-6 tw-rounded tw-border tw-bg-[#43d9a31f] tw-border-success-dark tw-text-success-dark tw-text-center">
                      <span>{t('AffiliazioneForm.success1')}</span>
                      {' '}
                      <Link<any>
                        target="_blank"
                        href={IMGPW + '/Affiliazione_Franchising_Long.mp4'}
                        className="tw-text-success-dark tw-font-semibold hover:tw-text-success">
                        Video
                      </Link>
                      {' '}
                      <span>{t('AffiliazioneForm.success2')}</span>
                      <br />
                      <span>{t('AffiliazioneForm.success3')}</span>
                      <div className="tw-flex tw-justify-center tw-mt-3">
                        <Link<any>
                          target="_blank"
                          href="https://calendly.com/giovanni-roberto/winelivery_franchising"
                          className="tw-button tw-btn-md tw-text-white tw-bg-[#006bff] hover:tw-bg-[#004bb2] hover:tw-text-white">
                          <div className="tw-flex tw-items-center tw-gap-1">
                            <span className="pe-7s-clock tw-font-bold" />
                            <span className="tw-text-balance">{t('AffiliazioneForm.book')}</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
                {status && !status.success && (
                  <div className="tw-col-span-2 tw-mt-5 md:tw-mt-0">
                    <Button
                      id="submit-affiliazione-b2b"
                      type="submit"
                      label={t('common.send')}
                      isSpinning={isSubmitting}
                      disabled={isSubmitting}
                      className={''}
                      style={{}}
                    />
                    <div className="tw-h-0 " />
                  </div>
                )}
              </div>
            </Form>

            <div className="tw-bg-[#d0334c] tw-my-10 tw-text-center tw-font-white tw-text-white tw-py-10 tw-w-full tw-text-2xl sm:tw-text-2xl tw-font-medium tw-tracking-tight">
              <div>
                <span>Schreiben Sie uns an </span>
                <a
                  href="mailto:affiliazione@winelivery.com"
                  className="hover:tw-text-white tw-font-bold tw-text-white"
                >
                  affiliazione@winelivery.com
                </a>
              </div>
              <div>oder rufen Sie Alessandro Colasuonno an</div>
              <div>Manager für Franchising-Entwicklung</div>
              <a
                className="tw-font-bold tw-text-white hover:tw-text-white"
                href="tel:+393405691136"
              >
                +39 340 5691 136
              </a>
            </div>

            <div className="tw-w-52 tw-h-40 tw-mb-10 position-relative tw-mx-auto">
              <Image
                fill
                style={{ objectFit: 'contain' }}
                className="tw-mx-auto"
                src={`${IMGPW}/Logo Assofranchising_Verticale.png`}
                alt="Logo Assofranchising"
              />
            </div>
          </div>
        );
      }}
    />
  );
};

export default SectionContact;
